import React, { useState } from "react";
import {FaMinus, FaPlus,FaCogs, FaShieldAlt, FaDollyFlatbed, FaWarehouse, FaClipboardList, FaUserCheck, FaHandshake, FaTruck, FaBoxes, FaGlobe, FaShippingFast, FaChartBar } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcarePLS/supply.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Transportation & Freight Management",
        "description": "Comprehensive logistics solutions for efficient cargo handling, shipping, and last-mile delivery. Utilizing multi-modal transportation (air, sea, road, and rail), advanced route optimization, fleet management, and real-time tracking, these solutions ensure the timely and cost-effective movement of goods. AI-driven analytics and IoT integration help reduce fuel consumption, optimize delivery schedules, and improve overall supply chain efficiency."
    },
    {
        "title": "Warehousing & Storage Solutions",
        "description": "State-of-the-art warehousing facilities equipped with automated storage systems, climate-controlled environments, and advanced inventory control technologies. These solutions ensure the safe and efficient handling of pharmaceuticals, perishable goods, and high-value products. Robotic automation, RFID tracking, and AI-driven inventory management enhance warehouse operations, reducing storage costs and minimizing errors."
    },
    {
        "title": "Inventory & Order Fulfillment",
        "description": "Seamless inventory tracking, demand forecasting, and order processing powered by AI and real-time analytics. Automated fulfillment centers streamline supply chain operations by optimizing stock levels, reducing waste, and ensuring order accuracy. Intelligent order routing and just-in-time (JIT) inventory strategies enhance customer satisfaction by minimizing delays and maximizing efficiency."
    },
    {
        "title": "Supply Chain Optimization",
        "description": "Leveraging AI, machine learning, and predictive analytics to enhance supply chain efficiency, reduce operational costs, and improve demand planning. Optimization strategies include real-time data analysis, supplier collaboration, and dynamic inventory allocation. Implementing just-in-time (JIT) inventory systems and blockchain-based tracking ensures greater transparency, agility, and resilience against supply chain disruptions."
    },
    {
        "title": "Global Logistics & Customs Compliance",
        "description": "End-to-end international trade management with expertise in customs regulations, import/export documentation, and duty optimization. Advanced digital solutions ensure smooth cross-border shipments, minimizing delays while maintaining compliance with global trade policies and industry regulations. AI-powered trade compliance tools help businesses navigate complex tariffs, sanctions, and customs clearance requirements efficiently."
    },
    {
        "title": "Risk Management & Compliance",
        "description": "Implementing robust security protocols, industry safety standards, and compliance frameworks to mitigate risks in logistics operations. Real-time monitoring of cargo, fraud prevention mechanisms, and AI-driven risk assessment tools help ensure regulatory adherence and operational security. Contingency planning and predictive risk modeling safeguard supply chains against disruptions, theft, and cyber threats."
    }
]

const features = [
    { icon: <FaTruck className="text-[#2a627a] text-lg" />, text: "Fast and efficient transportation network for global delivery." },
    { icon: <FaWarehouse className="text-[#2a627a] text-lg" />, text: "Advanced inventory management systems for real-time tracking." },
    { icon: <FaBoxes className="text-[#2a627a] text-lg" />, text: "Optimized warehouse storage for cost-effective operations." },
    { icon: <FaCogs className="text-[#2a627a] text-lg" />, text: "Automated logistics solutions for seamless supply chain processes." },
    { icon: <FaGlobe className="text-[#2a627a] text-lg" />, text: "Global sourcing and supplier management for quality assurance." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Robust compliance with regulatory and safety standards." }
];
const benefits = [
    { icon: <FaShippingFast className="text-[#2a627a] text-lg" />, text: "Ensures timely and efficient delivery of goods." },
    { icon: <FaChartBar className="text-[#2a627a] text-lg" />, text: "Reduces operational costs through optimized logistics planning." },
    { icon: <FaDollyFlatbed className="text-[#2a627a] text-lg" />, text: "Enhances warehouse efficiency with smart inventory tracking." },
    { icon: <FaGlobe className="text-[#2a627a] text-lg" />, text: "Facilitates seamless global trade and distribution." },
    { icon: <FaBoxes className="text-[#2a627a] text-lg" />, text: "Minimizes supply chain risks with strong contingency planning." },
    { icon: <FaHandshake className="text-[#2a627a] text-lg" />, text: "Strengthens supplier relationships for better cost efficiency." }
];
const cmsFeatures = [
    {
        icon: <FaUserCheck className="text-[#2a627a] text-lg" />,
        title: "Logistics Manager",
        text: "Oversees transportation, distribution, and supply chain efficiency."
    },
    {
        icon: <FaWarehouse className="text-[#2a627a] text-lg" />,
        title: "Inventory Specialist",
        text: "Manages stock levels, storage conditions, and warehouse operations."
    },
    {
        icon: <FaClipboardList className="text-[#2a627a] text-lg" />,
        title: "Supply Chain Analyst",
        text: "Optimizes logistics networks and demand forecasting."
    },
    {
        icon: <FaHandshake className="text-[#2a627a] text-lg" />,
        title: "Procurement Officer",
        text: "Manages supplier relationships and ensures quality sourcing."
    }
];
const SupplyChainLogistics = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex"> Supply Chain & Logistics - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Ensuring timely, efficient, and secure delivery of healthcare products through integrated and cost-effective logistics solutions."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Supply Chain & Logistics?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Supply Chain & Logistics in healthcare ensures the efficient production, storage, and distribution of medical
                            products, including pharmaceuticals and medical devices. At HIKEHEALTH GS, we implement advanced logistics
                            solutions to optimize inventory management, reduce delays, and ensure timely delivery of life-saving medications
                            and healthcare supplies. Our focus is on maintaining product integrity, regulatory compliance, and seamless
                            distribution to improve patient care worldwide.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Supply Chain & Logistics
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default SupplyChainLogistics;
